// Session-scoped sort persistence with a 24h TTL.
//
// The user wants their column-sort override to persist while they're
// actively working (in-app navigation) but reset on tab close OR after
// a day. sessionStorage handles tab-close naturally; the TTL handles
// the "lasts a day" requirement when a tab is left open for a long time.

const TTL_MS = 24 * 60 * 60 * 1000;

export function readSessionSort(key) {
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return null;
    const { ordering, setAt } = JSON.parse(raw);
    if (!ordering || typeof setAt !== 'number') return null;
    if (Date.now() - setAt > TTL_MS) {
      sessionStorage.removeItem(key);
      return null;
    }
    return ordering;
  } catch {
    return null;
  }
}

export function writeSessionSort(key, ordering) {
  try {
    sessionStorage.setItem(
      key,
      JSON.stringify({ ordering, setAt: Date.now() })
    );
  } catch {
    // sessionStorage can throw in private mode / when full — silently ignore
  }
}

export function clearSessionSort(key) {
  try {
    sessionStorage.removeItem(key);
  } catch {
    // ignore
  }
}
